import { BasicClient } from "@/utils/httpClient";

export default class Certificates {
  client: BasicClient;
  constructor() {
    this.client = new BasicClient();
  }

  newCertificate(params) {
    let body = {
      fullName: params.name,
      jobPosition: params.position,
      email: params.email,
      companyName: params.companyName,
      companyUniqueId: params.uniqueId,
      password: params.password,
      documentUnique: params.documentUnique,
    };
    return this.client.exec(`/v2/company/sign/certificate`, "POST", body);
  }

  getCertificatesList() {
    return this.client.exec(`/v2/company/sign/certificate`, "GET");
  }
  getSignCertificatesEnabled(){
    return this.client.exec(`/v2/company/sign/certificates-enabled`, "GET");
  }
  getCertificateEnabled(documentType) {
    return this.client.exec(
      `/v2/company/sign/certificate-enabled-and-permissions?documentType=${documentType}`,
      "GET"
    );
  }

  sendNotificationNewCertificate(emailNotification) {
    let body = {
      email: emailNotification,
    };
    return typeof emailNotification !== "undefined"
      ? this.client.exec(
          `/v2/company/sign/new-certificate-request`,
          "POST",
          body
        )
      : this.client.exec(`/v2/company/sign/new-certificate-request`, "POST");
  }

  expireCertificate(id){
    return this.client.exec(`/v2/company/sign/certificate/${id}`, "DELETE");
  }
}
